import React from 'react';

interface MenuItemProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
}

export const MenuItem: React.FC<MenuItemProps> = ({ children, onClick, href }) => {
  if (href) {
    return (
      <a
        href={href}
        onClick={onClick}
        className="flex justify-center items-center gap-[10px] hover:text-[#C3AC7A] transition-colors bg-transparent cursor-pointer no-underline"
        style={{ background: 'transparent' }}
      >
        <div className="text-white text-[20px] md:text-[35px] font-semibold leading-tight md:leading-[51.8px] font-['Figtree']" style={{ background: 'transparent' }}>
          {children}
        </div>
      </a>
    );
  }

  return (
    <button
      onClick={onClick}
      className="flex justify-center items-center gap-[10px] hover:text-[#C3AC7A] transition-colors bg-transparent border-none outline-none focus:outline-none hover:bg-transparent active:bg-transparent focus:bg-transparent cursor-pointer"
      style={{ background: 'transparent' }}
    >
      <div className="text-white text-[20px] md:text-[35px] font-semibold leading-tight md:leading-[51.8px] font-['Figtree']" style={{ background: 'transparent' }}>
        {children}
      </div>
    </button>
  );
};
